import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';   
export const useCryptosSocket = (rootPath) => {
    const EMIT_CRYPTOS_BET = async (
        data: {
            amount: string;
            frontID: number;
            isFast: boolean;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            roll_number: [];
            winAmount: number;
            [key: string]: any; // 前端将追加其它值
        }>(`${rootPath}.cryptos.bet`, data);
    };

    return {
        EMIT_CRYPTOS_BET,
    };
};
